import SubmissionsTabs from 'forms-utils-lib/urls/constants/SubmissionsTabs';
import getSubmissionsAppUrl from 'forms-utils-lib/urls/submissions/getSubmissionsAppUrl';
const getSubmissionsRouteUrl = (guid, tab = SubmissionsTabs.SUBMISSIONS, options = {}) => {
  const {
    resource = 'form'
  } = options;
  const baseUrl = getSubmissionsAppUrl(options.portalId);
  switch (tab) {
    case SubmissionsTabs.PERFORMANCE:
      return `${baseUrl}/${resource}/${guid}/performance`;
    case SubmissionsTabs.ANSWERS:
    case SubmissionsTabs.ANALYZE:
      return `${baseUrl}/${resource}/${guid}/analyze`;
    case SubmissionsTabs.SUBMISSIONS:
    default:
      return `${baseUrl}/${resource}/${guid}/submissions`;
  }
};
export default getSubmissionsRouteUrl;